import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "landing-slider" }
const _hoisted_2 = { class: "landing-slider__slide" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_slider = _resolveComponent("app-slider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_slider, _mergeProps({
      "pagination-align": "bottom-center",
      data: _ctx.sliderData,
      style: _ctx.sliderStyle
    }, { config: _ctx.config }, {
      class: "landing-slider__slider",
      onChange: _ctx.onSlideChange
    }), {
      slide: _withCtx(({ data }) => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "landing-slider__image",
            style: _normalizeStyle(data.slideStyle || {})
          }, null, 4)
        ])
      ]),
      _: 1
    }, 16, ["data", "style", "onChange"])
  ]))
}